import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'

import {
  Loading,
  CustomModal,
  CustomCheckbox,
  CustomDataTableHeader,
} from '../../../../../components'
import * as UsuarioHttp from '../../../../../services/api/https/settings/user.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'

class ModalUsuarioCentralOperacoes extends Component {
  constructor(props) {
    super(props)
    const { userId, show } = props
    this.state = { userId, associacoes: [], isLoading: true, show, globalFilter: '' }
  }
  onCheckBoxClicked = async associacao => {
    try {
      const { user_id, operationcenter_id, actived } = associacao
      const associacoes = await UsuarioHttp.userOperationCenterAssoctionHandler({
        user_id,
        operationcenter_id,
        actived: !actived,
      })
      this.setState({ associacoes })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  componentDidMount = async () => {
    try {
      const associacoes = await UsuarioHttp.getCentraisOperacionaisByUserId(this.state.userId)
      this.setState({ associacoes, isLoading: false })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    }
  }
  render() {
    const { isLoading, show } = this.state
    const { onClose } = this.props
    return (
      <CustomModal
        header="Associação Usuário x Centrais Operacionais"
        isVisible={show}
        onClose={() => onClose('showModalCentralOperacoes')}
      >
        {isLoading ? (
          <div className="text-center">
            <Loading size="md" />
          </div>
        ) : (
          this._getMainContent()
        )}
      </CustomModal>
    )
  }
  _getMainContent = () => {
    return (
      <DataTable
        value={this.state.associacoes}
        paginator={true}
        rows={5}
        globalFilter={this.state.globalFilter}
        header={
          <CustomDataTableHeader onChange={value => this.setState({ globalFilter: value })} />
        }
      >
        <Column
          field="actived"
          header=""
          style={{ textAlign: 'center', width: 100 }}
          body={(rowData, column) => (
            <CustomCheckbox
              checked={rowData.actived}
              onChange={() => this.onCheckBoxClicked(rowData)}
            />
          )}
        />
        <Column field="operationcenter_name" header="Central Operacional" />
      </DataTable>
    )
  }
}
export default connect()(ModalUsuarioCentralOperacoes)
